import { useQuery } from '@tanstack/react-query';
import { configApi } from '../lib/api/config';

/**
 * Whether client review invite emails are switched on (server ENABLE_CLIENT_REVIEW_INVITES,
 * read per request into GET /api/config/extension features.clientReviewInvites).
 * While off, the dashboard hides the Client emails field, the Client and Reminders
 * columns and their entry points (Emily, 2026-10-12). FAILS CLOSED: unknown, loading or
 * a failed config read all hide them, matching the server's default-off.
 */
export function useClientReviewInvitesEnabled(): boolean {
  const { data } = useQuery({
    queryKey: ['config', 'client-review-invites'],
    queryFn: () => configApi.getExtensionConfig().then((c) => c.features?.clientReviewInvites === true),
    staleTime: 60 * 1000,
    retry: false,
  });
  return data === true;
}
